module.exports = __webpack_public_path__ + "images/a3af4455418d52fde1ed72d4766518d3.svg";